import { isVodacomVersion } from "../../../constants/gaming";
import ServiceSelection from "./ServiceSelection";
import ServiceSelectionOld from "./ServiceSelectionOld";

const LaunchPad: React.FC = () => {
  return isVodacomVersion ? <ServiceSelection /> : <ServiceSelectionOld />;
};

export default LaunchPad;
